import { Store } from '@ngrx/store';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

import { ProductUid } from '../../domain/models/related-products.models';
import { mapProductsToProductUids } from '../transformers/products-to-product-uids.transformer';

import { CartItem } from '@api/cart/cart.models';
import { getStoreId } from '@core/infrastructure/state/core.selectors';
import { ProductPublicModels } from '@features/products/product';
// eslint-disable-next-line jira-ticket-todo-comment/jira-ticket-todo-comment
// TODO: Dependencia no deseada
import { getProductPageDetail } from '@pages/product';
import { ProductViewedService } from '@shared/product/services/product-viewed.service';
import { getShopCartCoreItems } from '@shared/shopcart-core/infrastructure/state/shopcart-core.selectors';

// #region CONSTANTS
// TO REFACTOR: should be configurable or maybe should be move to the domain layer
const RECENTLY_VIEWED_PRODUCT_MAX_AGE = 30;
// #endregion CONSTANTS

// #region PRIVATE
const filterExpiredProducts = (state) => {
    const numDaysBetween = (d1: number, d2: number) => {
        const diff = Math.abs(d1 - d2);
        return diff / (1000 * 60 * 60 * 24);
    };

    // eslint-disable-next-line no-param-reassign
    state.products = state.products.filter((product) => {
        return numDaysBetween(product.timestamp, new Date().getTime()) < RECENTLY_VIEWED_PRODUCT_MAX_AGE;
    });

    return state;
};

const filterCurrentProduct = (state: any, currentProduct: ProductPublicModels.PublicProduct): any => {
    return {
        ...state,
        products: state.products.filter(
            product => product.mocaId !== currentProduct?.mocaId
        ),
    };
};

const findRecentlyViewedProducts = (
    productViewedService: ProductViewedService,
    storeId: string,
    product: ProductPublicModels.PublicProduct,
    cartItems?: CartItem[],

): ProductUid[] => {
    const recentlyState = productViewedService.getStateRecentlyViewed();

    if (!recentlyState || typeof recentlyState === 'string' || !recentlyState.products || recentlyState.products.length === 0) {
        return [];
    }
    const stateWithoutExpired = filterExpiredProducts(recentlyState);
    productViewedService.setProductAsViewed(stateWithoutExpired, storeId);

    const stateWithoutCurrentProduct = filterCurrentProduct(stateWithoutExpired, product);
    const stateWithoutCartProducts = stateWithoutCurrentProduct.products.filter(
        productViewed => !cartItems?.some(cartItem => String(cartItem.parentId) === productViewed?.mocaId)
    );
    const recentlyViewedUidArray = mapProductsToProductUids(stateWithoutCartProducts);

    const reverseRecentlyViewedUidArray = recentlyViewedUidArray.reverse();

    return reverseRecentlyViewedUidArray;
};
// #endregion PRIVATE

// #region PUBLIC
export const getRecentlyViewedProducts = (
    store: Store,
    productViewedService: ProductViewedService,
): Observable<ProductUid[]> => {
    // TO REFACTOR: Get the store details as a parameter would reduce the coupling and complexity of this function
    return combineLatest([
        store.select(getProductPageDetail),
        store.select(getStoreId),
        store.select(getShopCartCoreItems),

    ]).pipe(
        map(([product, storeId, cartItems]) =>
            findRecentlyViewedProducts(productViewedService, storeId, product, cartItems))
    );
};
// #endregion PUBLIC

// #region __TESTS__
export const __tests__ = {
    filterCurrentProduct,
    findRecentlyViewedProducts,
};
// #endregion __TESTS__
